import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../../app/app-env';
import {frefFromRef, frefToRef} from '../../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import {OEFNStartSelectionModel, OEFNStartSelectionPropTypes} from './oe-fn-start-selection-model';

export class OEFNStartSelectionCurrentItemTitle extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.model = new OEFNStartSelectionModel(this.props.content);

        this.title = '';

        this.updateLanguage = this.updateLanguage.bind(this);
    }

    getTitle()  {
        return this.title;
    }

    componentWillReceiveProps(nextProps)   {
        let contentChanged = !OEToolbox.shallowEqual(nextProps.content, this.props.content, true);

        if(contentChanged)   this.model = new OEFNStartSelectionModel(nextProps.content);

        if(nextProps.target !== this.props.target || contentChanged)  this.updateLanguage(nextProps);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage(props)   {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        let si = this.oe.sharedInterface;

        let item = this.model.itemForTarget(props.target);

        let itemTitle = '';
        if(item && item.label)    {
            itemTitle = item.label.id ? si.getLocalizedStringEnc(item.label.id) : (item.label.text ? item.label.text : '');
        }

        if(this.title != itemTitle) {
            this.title = itemTitle;
            if(this.props.onTitleChanged)   this.props.onTitleChanged(this, this.title);
        }
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    render() {
        return <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
    }
}

OEFNStartSelectionCurrentItemTitle.defaultProps = {
    moduleId: '',
    target: ''
};

OEFNStartSelectionCurrentItemTitle.propTypes = {
    moduleId: PropTypes.string,
    target: PropTypes.string,
    content: OEFNStartSelectionPropTypes.content,
    onTitleChanged: PropTypes.func
};

export default frefFromRef(connectAppEnv((env) => {
    return {
        target: env.config.target,
        content: env.config.module.uiLayerConfig.startSelection.content
    };
})(frefToRef(OEFNStartSelectionCurrentItemTitle)));